module.exports = __webpack_public_path__ + "img/cancercouncil-act.65010a2.png";